/**
 * Yup validation schemas for the User form.
 *
 * Variants are composed from a `baseValidations` block so that adding
 * a field in the future requires touching a single source of truth.
 */

import { MAX, PASSWORD_MIN, PASSWORD_REGEX, PASSWORD_REPEAT_TEXT, REQUIRED } from 'app/utils/yupMessage';
import * as Yup from 'yup';

const regexPassword = /^$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/;

const baseValidations = {
  change_password: Yup.string(),
  groups: Yup.array().of(Yup.object({})),
  lastname: Yup.string().max(50, MAX).required(REQUIRED),
  name: Yup.string().max(50, MAX).required(REQUIRED),
  password: Yup.string(),
  password_repeat: Yup.string().oneOf([Yup.ref('password'), null], PASSWORD_REPEAT_TEXT),
  role: Yup.string(),
  school: Yup.object(),
  username: Yup.string().required(REQUIRED),
};

const passwordWithRules = Yup.string()
  .matches(regexPassword, PASSWORD_REGEX)
  .test('empty-or-10-characters-check', PASSWORD_MIN, (password?: string) => !password || password.length >= 10);

const requiredCountry = Yup.object().required(REQUIRED);

export const ModelYup = Yup.object().shape(baseValidations);

export const ModelYupNotRequired = Yup.object().shape({
  ...baseValidations,
  lastname: Yup.string().max(50, MAX),
  name: Yup.string().max(50, MAX),
  username: Yup.string(),
});

export const ModelYupMultiCountry = Yup.object().shape({
  ...baseValidations,
  country: requiredCountry,
});

export const ModelYupPassword = Yup.object().shape({
  ...baseValidations,
  password: passwordWithRules,
});

export const ModelYupPasswordMultiCountry = Yup.object().shape({
  ...baseValidations,
  country: requiredCountry,
  password: passwordWithRules,
});
